<template>
	<div class="comp">
	<div class="grid settings comp-inner">
	<div class="grid header">
		<div class="grid sectiontitle"><span @click="show('dashboard')"><unicon name="arrow-left" height="32" width="32" /></span>Impostazioni</div>
		<div class="grid settings">
			<transition name="slide-fade">
				<button @click="save()" v-if="changes" class="btn green" v-loading="hotelloading"><unicon name="save" fill="#fff" /> Salva modifiche</button>
			</transition>
			<!-- <span @click="show('billing')" class="btn dark"><unicon name="receipt" height="14" width="14" fill="#fff" /> Fatturazione</span> -->
			<span @click="show('editgrid')" class="btn"><unicon name="draggabledots" height="14" width="14" /> Modifica spiaggia</span>
			<button @click="openmenu()" class="btn"><i class="fas fa-bars"></i></button>
		</div>
		</div>

		<div class="grid settingslist">

			<div>

				<div class="grid box hotel">
					
					<div class="grid header">
						<span class="grid title">Impostazioni generali</span>
<!-- 						<el-popover
							width="400"
							trigger="click">
							<button class="btn red sm">cancella dati</button>
							<el-button slot="reference"><unicon name="ellipsis-v" /></el-button>
						</el-popover> -->
					</div>
					<div class="grid body">
						<el-form ref="hotelform" :model="hotel" status-icon>
						<div class="grid items">
							<el-form-item label="Nome spiaggia" key="name" prop="name" class="input">
								<el-input type="text" v-model="hotel.name" name="name"></el-input>
							</el-form-item>
							<el-form-item label="Indirizzo" key="address" prop="address" class="input">
								<el-input type="text" v-model="hotel.address" name="address"></el-input>
							</el-form-item>
							<el-form-item label="Cittá" key="city" prop="city" class="input">
								<el-input type="text" v-model="hotel.city" name="city"></el-input>
							</el-form-item>
							<el-form-item label="Cap" key="cap" prop="cap" class="input">
								<el-input type="text" v-model="hotel.cap" name="cap"></el-input>
							</el-form-item>
							<el-form-item label="Provincia" key="prov" prop="prov" class="input">
								<el-input type="text" v-model="hotel.prov" name="prov"></el-input>
							</el-form-item>
							<el-form-item label="Paese" key="country" prop="country" class="input">
								<el-input type="text" v-model="hotel.country" name="country"></el-input>
							</el-form-item>
							<!-- <div class="grid item">
								<el-form-item label="Nome stabilimento" key="name" prop="name" class="input">
									<el-input type="text" v-model="hotel.name" name="name"></el-input>
								</el-form-item>
							</div>
							<div class="grid item">
								<el-form-item label="Indirizzo stabilimento" key="name" prop="name" class="input">
									<el-input type="text" v-model="hotel.address" name="address"></el-input>
								</el-form-item>
							</div> -->
						</div>
						</el-form>
						<!-- {{hotel}} -->
					</div>
					
				</div>

				<div class="spacer lg"></div>

				<div class="grid box" v-if="$store.state.user.privileges.admin">
					
<!-- 					<div class="grid header">
						<span class="grid title"></span>
					</div> -->
					<div class="grid body">

						<div class="grid items" key="items">
							<div class="grid item">
								<span class="grid badge">
									<button class="btn red sm" @click="deletebeach = true">cancella dati</button>
								</span>
								<span class="grid icon"><unicon name="exclamation-triangle" fill="#FF0132" /></span>
								<span class="grid name">Cancella spiaggia</span>
							</div>
						</div>

					</div>

				</div>

			</div>

			<div class="grid box beachsettings">
				<div class="grid header">
					<span class="grid title">Impostazioni ombrellone</span>
				</div>
				<div class="grid body">
					<!-- {{hotel.settings.room}} -->
					<div class="grid items" key="items">
						<div v-for="item in hotel.items" :key="item.icon" class="grid item">
							<span class="grid badge">
								<el-input-number v-model="item.num" size="mini" :min="0"></el-input-number>
							</span>
							<span class="grid icon invert" v-html="item.icon"></span>
							<span class="grid name">{{item.name}}</span>
						</div>
						<div class="spacer xs"></div>
						<div class="grid item">
							<span class="grid badge">
								<el-switch v-model="hotel.settings.room"></el-switch>
							</span>
							<span class="grid icon"><unicon name="key-skeleton" /></span>
							<span class="grid name">Numero camera</span>
						</div>
						<div class="grid item">
							<span class="grid badge">
								<el-switch v-model="hotel.cashier"></el-switch>
							</span>
							<span class="grid icon"><unicon name="invoice" /></span>
							<span class="grid name">Calcolo checkout</span>
						</div>
						<!-- <div class="grid item">
							<span class="grid badge">
								<el-switch v-model="hotel.settings.publicbooking"></el-switch>
							</span>
							<span class="grid icon"><unicon name="book-reader" /></span>
							<span class="grid name">Booking publico <a :href="'http://localhost:8080/beach/' + hotel._id" target="new"><unicon name="link" v-if="hotel.settings.publicbooking" height="16" /></a></span>
						</div> -->
<!-- 						<div class="grid item">
							<span class="grid badge">
								<el-switch v-model="hotel.magazine"></el-switch>
							</span>
							<span class="grid icon"><unicon name="invoice" /></span>
							<span class="grid name">Magazino</span>
						</div> -->
					</div>
				</div>
			</div>

			<!-- {{hotelsettings}} -->

			<!-- <p>{{$store.state.hotels.hotels[3]}}</p> -->

		</div>
	</div>

	<el-dialog
        title=""
        :visible.sync="deletebeach"
        width="fit-content"
        :show-close="true"
        custom-class="needstoconvert">
        <template slot="title">
          <div class="grid header">
            <div class="title" style="font-size: 20px;">Oh boy</div>
          </div>
        </template>
        <div>
            <h3>Attenzione, stai per cancellare {{hotel.name}}</h3>
            <div class="spacer xs"></div>
            <p>se procedi {{hotel.name}} verrá cancellata irreversibilmente assieme a tutti gli ombrelloni e i dati degli ospiti.</p>
            <!-- <span class="btn reddark sm"><unicon name="thumbs-up" fill="#fff" /> ok, se proprio doviamo</span> -->
            <div class="grid actions" style="grid-auto-flow: column; padding: 0; margin-top: 64px; justify-content: end; grid-column-gap: 24px;">
              <span @click="deletebeach = false" class="btn secondary light sm">no, non cancellare</span>
              <span class="btn reddark sm" @click="deleteHotel"><unicon name="exclamation-triangle" fill="#fff" /> ok, cancella spiaggia</span>
            </div>
        </div>
    </el-dialog>

</div>
</template>

<script>
import _ from 'lodash'
// import moment from 'moment'
import helper from '../Mixins/helper'
export default {
	name: 'Settings',
	mixins: [helper],
	props: {
	// hotel: Object
	},
	data () {
	return {
		hotel: {},
		changes: false,
		deletebeach: false
	}
	},
	methods: {
		deleteHotel () {
			this.$store.dispatch('hotels/deleteHotel').then(() => {
				this.deletebeach = false
				this.$store.state.hotels.hotels.length > 0 ? this.$store.commit('hotels/SET_SELECTHOTELDIALOG', true) : this.$emit('open', 'addbeach')
			}).catch((err) => {
				console.log(err)
			})
		},
		show (section) {
			console.log(section)
			this.$emit('open', section)
		},
		save () {
			console.log('save')
			this.$store.dispatch('hotels/updateHotel', this.hotel)
		}
	},
	filters: {

	},
	watch: {
	// '$store.state.hotels.activehotel.items': {
	// 	immediate: true,
	// 	deep: true,
	// 	handler (newval, oldval) {
	// 		console.log('watch: ', oldval, newval)
	// 	}
	// },
	hotel: {
		// immediate: true,
		deep: true,
		handler (newval, oldval) {
			console.log('watch room: ', newval.room, oldval.room, this.$store.state.hotels.activehotel.room)
			console.log('watch: ', _.isEqual( newval, this.$store.state.hotels.activehotel))
			// this.changes = _.isEqual( newval, this.$store.state.hotels.activehotel)
			if (_.isEqual( newval, this.$store.state.hotels.activehotel)) {
				this.changes = false
			} else {
				this.changes = true
			}
		}
	}
	},
	computed: {
	hotelloading () {
		return this.$store.state.hotels.loading
	}
	// hotelsettings () {
	// 	var clone = _.clone(this.$store.state.hotels.activehotel, true)
	// 	return clone
	// }
	},
	beforeMount () {
	this.hotel = JSON.parse(JSON.stringify(this.$store.state.hotels.activehotel))
	},
	beforeDestroy () {
	console.log('beforeClose', _.isEqual(this.hotel, this.$store.state.hotels.activehotel))
	// if (!_.isEqual(this.hotel, this.$store.state.hotels.activehotel)) {
	// 	this.$store.commit('hotels/SET_ACTIVEHOTEL', this.hotel)
	// }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active {
	transition: opacity .5s;
}
.fade-leave-active {
	transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all .3s ease;
}
.slide-fade-leave-active {
	transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(10px);
	opacity: 0;
}
</style>
